// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".media .image[data-v-d4d5dfe4]{margin-top:6px}.account-picker[data-v-d4d5dfe4]  .dropdown-menu,.dropdown-item[data-v-d4d5dfe4]{min-width:280px}.dropdown-item[data-v-d4d5dfe4]{padding-right:1rem}.client-name[data-v-d4d5dfe4]{max-width:180px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
